module.exports = __webpack_public_path__ + "img/current.c7e9b0c7.png";